import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  QueryList,
} from '@angular/core';

import { GasTabsHelper } from '../gas-tabs-helper';
import { GasTabsType } from '../gas-tabs.interface';
import { GasTabComponent } from '../tab/gas-tab.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'gas-tabs',
  templateUrl: './gas-tabs.component.html',
  styleUrls: ['./gas-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasTabsComponent implements AfterContentInit {
  @Output()
  public selectedChange = new EventEmitter<GasTabComponent>();
  /** Тип обертки для табов */
  @Input()
  public type: GasTabsType = 'default';

  @HostBinding('class._scoped')
  public get scoped(): boolean {
    return this.type === 'scoped';
  }

  /** Табы */
  @ContentChildren(GasTabComponent)
  public tabs: QueryList<GasTabComponent>;

  private activeTab: GasTabComponent;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  /** Проверяем, если среди табов нет активного, делаем активным первый таб */
  public ngAfterContentInit(): void {
    const activeTabs = this.tabs.filter((tab) => tab.active as boolean);

    if (!activeTabs.length) {
      this.selectTab(this.tabs.first);
    } else {
      this.activeTab = activeTabs[0];
    }

    /** подписываемся на динамику в табах */
    this.tabs.changes
      .pipe(
        untilDestroyed(this),
      ).subscribe(() => {
        let activeTab: GasTabComponent;
        this.tabs.forEach(tab => {
          /** ищем активный таб не равный текущему */
          if (tab.active) {
            activeTab = this.activeTab.id !== tab.id ? tab : this.activeTab;
          }
        });
        this.selectTab(activeTab || this.tabs.last);
        this.changeDetectorRef.detectChanges();
      });

    /** подписка на изменение инпутов в табах */
    GasTabsHelper.changeTabsStateSubject$
      .pipe(
        untilDestroyed(this),
      ).subscribe(() => this.changeDetectorRef.detectChanges());
  }

  /** Обработка клика по табу */
  public selectTab(tab: GasTabComponent): void {
    if (tab.disabled) {
      return;
    }

    this.tabs.toArray().forEach((innerTab: GasTabComponent) => innerTab.active = false);

    tab.active = true;

    this.activeTab = tab;
    this.selectedChange.emit(tab);
    GasTabsHelper.changeTabsStateSubject$.next(true);
  }
}
